<template>
    <div class="section legal-section fade-in-section">
        <h2 class="section-title">Legal</h2>

        <div class="legal-cards stagger-children">
            <router-link to="/privacy" class="legal-card">
                <Shield :size="40" class="icon" />
                <h3>Privacy Policy</h3>
                <p>How we collect, use, and protect your personal data</p>
                <span class="card-link">
                    Read More
                    <ArrowRight :size="16" />
                </span>
            </router-link>

            <router-link to="/terms" class="legal-card">
                <FileText :size="40" class="icon" />
                <h3>Terms of Service</h3>
                <p>Rules and guidelines for using Curie</p>
                <span class="card-link">
                    Read More
                    <ArrowRight :size="16" />
                </span>
            </router-link>
        </div>
    </div>
</template>

<script>
import { Shield, FileText, ArrowRight } from 'lucide-vue-next';

export default {
    name: 'LegalLinksSection',
    components: {
        Shield,
        FileText,
        ArrowRight
    }
};
</script>

<style scoped>
.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid var(--accent);
}

.section-title {
    font-size: 42px;
    color: var(--text-secondary);
    text-align: center;
    margin-bottom: 60px;
}

.legal-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    max-width: 800px;
    margin: 0 auto;
}

.legal-card {
    background: rgba(var(--bg-secondary-rgb), 0.95);
    padding: 40px 30px;
    text-align: center;
    text-decoration: none;
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: transform 0.3s ease, border-color 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.legal-card:hover {
    transform: translateY(-5px);
    border-color: var(--accent);
}

.icon {
    color: var(--accent);
    margin-bottom: 20px;
}

.legal-card h3 {
    font-size: 22px;
    color: var(--text-primary);
    margin-bottom: 12px;
    font-weight: 600;
}

.legal-card p {
    font-size: 15px;
    color: var(--text-secondary);
    line-height: 1.6;
    margin-bottom: 20px;
}

.card-link {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--accent);
    font-size: 14px;
    font-weight: 500;
    margin-top: auto;
}

.legal-card:hover .card-link {
    text-decoration: underline;
}

/* Fade-in animation */
.fade-in-section {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: translateY(0);
}

/* Stagger children animations */
.stagger-children > * {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.stagger-children.is-visible > * {
    opacity: 1;
    transform: translateY(0);
}

.stagger-children.is-visible > *:nth-child(1) { transition-delay: 0.1s; }
.stagger-children.is-visible > *:nth-child(2) { transition-delay: 0.2s; }

@media (max-width: 768px) {
    .section {
        min-height: auto;
        padding: 60px 20px;
    }

    .section-title {
        font-size: 32px;
        margin-bottom: 40px;
    }

    .legal-cards {
        grid-template-columns: 1fr;
    }

    .legal-card {
        padding: 30px 20px;
    }
}
</style>
